import React from 'react'
import { Box } from '@mui/material'

interface Props {
  /** Clicking the scrim closes the drawer; omitted where the drawer must not be dismissed from outside. */
  onClick?: () => void
}

/**
 * Dims and blurs the page under a flow drawer. `ResponsiveDrawer` disables pointer events on MUI's own backdrop,
 * so the flow draws its own.
 */
export const PfDrawerScrim: React.FC<Props> = ({ onClick }) => (
  <Box
    onClick={onClick}
    data-cy="pf-revamp-drawer-scrim"
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: (theme) => theme.zIndex.drawer - 1,
      backdropFilter: 'blur(3px)',
      backgroundColor: 'rgba(37, 42, 46, 0.4)',
      animation: 'pfScrimIn 220ms ease',
      '@keyframes pfScrimIn': { from: { opacity: 0 }, to: { opacity: 1 } },
    }}
  />
)
